module.exports = __webpack_public_path__ + "static/truck-80fed41728355edee114754ea457e307.png";